export default __webpack_public_path__ + "static/media/heartFull.3c660ffe.svg";